module.exports = __webpack_public_path__ + "static/media/pic00.36d241e7.svg";